module.exports = __webpack_public_path__ + "img/14.21542ab0.jpg";